import { useStaticQuery, graphql } from "gatsby";
import useLocale from "./useLocale";
import { getOriginalLocale } from "@helpers/GlobalHelpers";

export enum PageConfigurationName {
	theAepsyWay = "theAepsyWay",
	selfEmployment = "selfEmployment",
}

export const usePageConfiguration = ({
	name,
}: {
	name: PageConfigurationName;
}) => {
	const { currentLanguage } = useLocale();

	const pageConfigurationsQuery = useStaticQuery(graphql`
        query {
            aepsyCms {
                pageConfigurationsDE:pageConfigurations(locale: "de-CH", pagination: { limit: 100 }) {
                    slug
                    locale
                    page
                    localizations {
                        slug
                        locale
                    }
                }
				pageConfigurationsEN: pageConfigurations(locale: "en", pagination: { limit: 100 }) {
                    slug
                    locale
                    page
                    localizations {
                        slug
                        locale
                    }
                }	
				pageConfigurationsFR: pageConfigurations(locale: "fr-CH", pagination: { limit: 100 }) {
                    slug
                    locale
                    page
                    localizations {
                        slug
                        locale
                    }
                }	
				pageConfigurationsIT: pageConfigurations(locale: "it", pagination: { limit: 100 }) {
                    slug
                    locale
                    page
                    localizations {
                        slug
                        locale
                    }
                }
            }
        }
    `);

	const { aepsyCms } = pageConfigurationsQuery;

	if (!aepsyCms) return null;

	const data = [
		...aepsyCms.pageConfigurationsDE,
		...aepsyCms.pageConfigurationsEN,
		...aepsyCms.pageConfigurationsFR,
		...aepsyCms.pageConfigurationsIT,
	];

	const foundItem = data.find(
		(item: any) =>
			item?.page === name &&
			getOriginalLocale(item?.locale) === currentLanguage,
	);

	if (!foundItem) return null;

	return foundItem;
};
